<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-lx-cascades"></i> 新闻活动
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<div class="title">新闻活动</div>
			<div class="handle-box">
				<el-input placeholder="新闻名称" class="handle-input mr10" v-model="menuName" clearable></el-input>
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				<el-button type="primary" icon="el-icon-circle-plus-outline" @click="createPerson">创建新闻</el-button>
			</div>
			<el-table :data="personList" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				v-loading="isloading" style="width: 100%">
				<!-- <el-table-column prop="Id" label="ID" align="center" fixed></el-table-column> -->
				<el-table-column prop="Name" label="新闻名称" align="center" fixed></el-table-column>
				<el-table-column prop="Author" label="新闻作者" align="center" fixed></el-table-column>
				<el-table-column prop="Source" label="新闻来源" align="center" fixed></el-table-column>
				<el-table-column prop="AddTime" label="添加时间" align="center" fixed></el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align="center">
					<template #default="scope">
						<el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
						<el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑
						</el-button>
						<el-button type="text" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)"
							style="color: red;">删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, prev, pager, next,sizes" :current-page="pageIndex"
					@size-change="handleSizeChange" :page-size="pageSize" :total="pageTotal"
					@current-change="handlePageChange" :page-sizes="[5, 10, 15,20]"></el-pagination>
			</div>
		</div>

		<el-dialog title="提示" v-model="isdelete" width="30%">
			<span>您确定删除吗？</span>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="isdelete = false">取 消</el-button>
					<el-button type="primary" @click="deleteNews">确 定</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- 编辑弹出框 查看弹出框-->
		<el-dialog :title="title" v-model="editVisible" width="30%">
			<el-form label-width="100px" ref="ruleForm" :model="ruleForm" :rules="rules">
				<el-form-item label="新闻名称" prop="Name">
					<el-input v-model="ruleForm.Name" :disabled="isdisabled"></el-input>
				</el-form-item>
				<el-form-item label="编辑" prop="Author">
					<el-input v-model="ruleForm.Author" :disabled="isdisabled"></el-input>
				</el-form-item>
				<el-form-item label="稿源" prop="Source">
					<el-input v-model="ruleForm.Source" :disabled="isdisabled"></el-input>
				</el-form-item>
				<el-form-item prop="State" label="标签">
					<el-select v-model="ruleForm.State" placeholder="请选择" :disabled="isdisabled">
						<el-option v-for="item in newsTagList" :key="item.value" :label="item.name" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="新闻内容" prop="Introduction">
					<!-- <el-input v-model="ruleForm.Introduction" :disabled="isdisabled"></el-input> -->
					<wenben :Introduction='ruleForm.Introduction' :isbianji='iseditor' @childvalue='childvalue'
						ref="mychild"></wenben>
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="editVisible = false" :disabled="isdisabled">取 消</el-button>
					<el-button type="primary" @click="saveEdit('ruleForm')" :disabled="isdisabled">确 定</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	import axios from 'axios'
	import qs from 'qs'
	import wenben from '../components/wenben.vue'
	import E from 'wangeditor'
	export default {
		components: {
			wenben
		},
		data() {
			return {
				isloading: true,
				isdelete: false, //删除弹出框
				deleteid: '',
				pageSize: 5,
				pageIndex: 1,
				pageTotal: '',
				name: '',
				menuName: '',
				isdisabled: false,
				ruleForm: [],
				title: '',
				editVisible: false,
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				personList: [],
				personName: '', //角色名称
				token: localStorage.getItem('access_token'),
				menuId: '',
				iseditor: false,
				rules: {
					Name: [{
						required: true,
						message: '请输入新闻名称',
						trigger: 'blur'
					}],
					Author: [{
						required: true,
						message: '请输入新闻作者',
						trigger: 'change'
					}],
					Source: [{
						required: true,
						message: '请输入新闻来源',
						trigger: 'blur'
					}],
					State: [{
						required: true,
						message: '请选择标签',
						trigger: 'change'
					}],
				},
				newsTagList: []
			}
		},
		created() {
			this.getNewsTag()
			this.getmenuId()
			this.getData()
		},
		methods: {
			getNewsTag() {
				axios({
					method: 'get',
					url: this.$store.state.url + "GetNewsTag",
				}).then((res) => {
					this.newsTagList = res.data.Data
				})
			},
			//删除
			handleDelete(index, row) {
				this.isdelete = true
				this.deleteid = row.Id
			},
			deleteNews() {
				axios({
					method: 'post',
					url: this.$store.state.pcurl + "DeleteNew?newsId=" + this.deleteid,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					if (res.data.Message == '请求成功') {
						this.isdelete = false
						this.$message({
							message: '删除新闻成功！',
							type: 'success'
						})
						this.getData()
					} else {
						this.$message.error('删除新闻失败！');
					}
				})
			},
			childvalue(val) {
				console.log(val)
				this.ruleForm.Introduction = val
			},
			//获取id
			getmenuId() {
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetMenu",
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					res.data.Data.forEach((x) => {
						if (x.Name == '新闻活动') {
							this.menuId = x.Id
							console.log(x)
						}
					})
					console.log(this.menuId)
				})
			},
			//搜索新闻
			handleSearch() {
				this.name = this.menuName
				this.pageIndex = 1
				this.getData()
			},
			handlePageChange(val) {
				this.pageIndex = val
				this.getData()
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.getData()
			},
			//创建新闻
			createPerson() {
				this.title = '创建新闻'
				this.ruleForm = []
				this.isdisabled = false
				this.iseditor = true
				this.editVisible = true
				this.ruleForm.Introduction = ''
			},
			//查看
			handleClick(row) {
				console.log(row)
				this.title = '查看'
				this.iseditor = true
				this.isdisabled = true
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetNewsModel?newsId=" + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					this.ruleForm = res.data.Data
					this.editVisible = true
				})
			},
			// 编辑
			handleEdit(index, row) {
				this.title = '编辑'
				this.iseditor = false
				this.isdisabled = false
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetNewsModel?newsId=" + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					this.ruleForm = res.data.Data
					this.editVisible = true
				})
			},
			//保存编辑
			saveEdit(ruleForm) {
				if (this.title == '编辑') {
					this.$refs[ruleForm].validate((valid) => {
						if (valid) {
							this.$refs.mychild.syncHTML()
							axios({
								method: 'post',
								url: this.$store.state.pcurl + "UpdateNews",
								data: qs.stringify(this.ruleForm),
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								if (res.data.Message == '请求成功') {
									this.editVisible = false
									this.$message({
										message: '修改成功',
										type: 'success'
									})
									this.getData()
								} else {
									this.$message.error('修改失败');
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else if (this.title = '创建新闻') {
					this.ruleForm.MenuId = this.menuId
					this.$refs[ruleForm].validate((valid) => {
						if (valid) {
							this.$refs.mychild.syncHTML()
							axios({
								method: 'post',
								url: this.$store.state.pcurl + "AddNews",
								data: qs.stringify(this.ruleForm),
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								if (res.data.Message == '请求成功') {
									this.editVisible = false
									this.$message({
										message: '创建成功',
										type: 'success'
									})
									this.getData()
								} else {
									this.$message.error('创建失败');
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else {
					this.editVisible = false
				}
			},
			getData() {
				var pageIndex = this.pageIndex - 1
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetNews?menuId=" + this.menuId + '&pageIndex=' + pageIndex +
						'&pageSize=' + this.pageSize + '&name=' + this.name,
					headers: {
						Authorization: 'bearer ' + this.token
					}
				}).then((res) => {
					if (res.data.Message == '请求成功') {
						this.isloading = false
						this.pageTotal = res.data.Count
						this.personList = res.data.Data
						this.personList.forEach((x) => {
							x.AddTime = x.AddTime.replace('T', ' ')
						})
					} else {
						this.$message.error('角色列表获取失败')
					}
				})
			},
		}
	};
</script>

<style scoped>
	.title {
		width: 100%;
		height: 120px;
		font-size: 36px;
		font-weight: bold;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.container {
		padding-top: 0;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	:deep(iframe) {
		height: 600px;
	}
</style>
